import { render, staticRenderFns } from "./DashboardNotification.vue?vue&type=template&id=7b86d8b0&scoped=true"
import script from "./DashboardNotification.vue?vue&type=script&lang=js"
export * from "./DashboardNotification.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotification.vue?vue&type=style&index=0&id=7b86d8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86d8b0",
  null
  
)

export default component.exports